import React from 'react'
import { View, Image, StyleSheet } from '@react-pdf/renderer'

interface QRCodeComponentProps {
  qrCodeDataUrl: string
  size?: number
}

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  image: {
    objectFit: 'contain',
  },
})

const QRCodeComponent: React.FC<QRCodeComponentProps> = ({ qrCodeDataUrl, size = 60 }) => {
  if (!qrCodeDataUrl) {
    return null
  }

  return (
    <View style={styles.container}>
      <Image src={qrCodeDataUrl} style={[styles.image, { width: size, height: size }]} />
    </View>
  )
}

export default QRCodeComponent

